(function ($) {
    $(function () {
        $('.accordion').accordion({
            collapsible: true,
            active: false,
            icons: {"header": "right fas fa-caret-down", "activeHeader": " right fas fa-caret-up"}
        });
    });
}(jQuery));



// WEBPACK FOOTER //
// ./resources/assets/js/accordion.js